















import { computed, defineComponent, getCurrentInstance } from "@vue/composition-api";
import useStateRedirectPath from "@/hooks/useStateRedirectPath";
import { useStaticPages } from "@/hooks/useStaticPages";

export default defineComponent({
  name: "FooterPolicy",
  setup() {
    const { stateRedirectPath } = useStateRedirectPath();
    const { pages, getPages } = useStaticPages();
    const visiblePages = computed(() => pages.value?.filter(page => page.visible) ?? []);
    const vm = getCurrentInstance();
    const contactUsLocation = computed(() => vm?.$router.resolve({ name: "messages", params: { userId: "1" } }));

    const contactClick = () => {
      stateRedirectPath.value = contactUsLocation.value?.location ?? null;
      vm?.$router.push({ name: "login" });
    };

    getPages();

    return { visiblePages, contactUsLocation, contactClick };
  },
});
